module.exports = __webpack_public_path__ + "img/gallery15.4d7c486c.jpg";